export default {
  getData: (state) => {
    return state.userInfo
  },
  getLog: (state) => {
    return state.logData
  }
}
